import React from 'react';
import { SOLES } from '../../../common/types/monedaType';
import kardexService from '../../../service/logistica/kardexService';
import almacenService from '../../../service/administracion/almacenService';
import establecimientoService from '../../../service/administracion/establecimientoService';
import monedaService from '../../../service/administracion/monedaService';
import productoService from '../../../service/administracion/productoService';
import global from '../../../common/utility/global';

import Header from '../../../components/Header';
import Filters from './Filters';
import EstablecimientoTable from './EstablecimientoTable';

export default class Index extends React.Component {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            establecimientos: [],
            almacenes: [],
            monedas: [],
            productos: [],
            productosAutocomplete: [],
            almacenesLoading: false,
            productosLoading: false,
            establecimientosLoading: false,
            monedasLoading: false,
            loadingExcel: false,
            filter: {
                idEstablecimiento: 0,
                idAlmacen: 0,
                fechaDesdeFormat: global.fetchCurrentDateStr(true),
                fechaHastaFormat: global.fetchCurrentDateStr(),
                idProducto: 0,
                codigoReferencia: '',
                idMoneda: SOLES
            },
            kardexDataSource: []
        }
    }

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter };
        }
    };

    handleChange = async (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });

        if (property === "idEstablecimiento") {
            this.setState({ almacenesLoading: true });
            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
            this.setState({
                filter: { ...this.state.filter, idAlmacen: undefined },
                almacenes: almacenes ? almacenes : [],
                almacenesLoading: false
            });
        }
    };

    handleClearFilters = () => {
        var filter = {
            idEstablecimiento: 0,
            idAlmacen: 0,
            fechaDesdeFormat: global.fetchCurrentDateStr(true),
            fechaHastaFormat: global.fetchCurrentDateStr(),
            idProducto: 0,
            codigoReferencia: '',

            idMoneda: SOLES
        };
        this.setState({ filter });
    };

    handleSearchAutocomplete = (value) => {
        const result = this.state.productos.filter(item => {
            return (item.nombre).toUpperCase().match(value.toUpperCase());
        }).slice(0, 75);
        this.setState({ productosAutocomplete: result });
    };

    handleChangeAutocomplete = (value) => {
        this.setState({
            filter: {
                ...this.state.filter,
                idProducto: value.key
            }
        });
    };

    handleClearAutocomplete = () => {
        this.setState({
            filter: {
                ...this.state.filter,
                idProducto: 0
            }
        });
    }


    handleSearchKardexEstablecimiento = async () => {
        const kardexDataSource = await kardexService.establecimientoAlmacen(this.state.filter);
        this.setState({
            kardexDataSource: kardexDataSource ? kardexDataSource : []
        });
    }

    handleSearchKardexProducto = async (expanded, item) => {

        if (!expanded) {
            return false;
        }
        var filter = {
            idAlmacen: item.id,
            fechaDesdeFormat: this.state.filter.fechaDesdeFormat,
            fechaHastaFormat: this.state.filter.fechaHastaFormat,
            idProducto: this.state.filter.idProducto,
            codigoReferencia: this.state.filter.codigoReferencia,
            idMoneda: this.state.filter.idMoneda
        }
        const productosKardex = await kardexService.producto(filter);

        var newKardexDataSource = [];

        this.state.kardexDataSource.forEach(element => {
            var item = { ...element };
            newKardexDataSource.push(item);
        });

        newKardexDataSource.forEach(establecimiento => {
            establecimiento.almacenes.forEach(almacen => {
                if (almacen.id === item.id) {
                    almacen.productos = productosKardex;
                }
            });
        });

        this.setState({ kardexDataSource: newKardexDataSource });
    }

    handleSearchKardexMovimiento = async (expanded, item) => {
        if (!expanded) {
            return false;
        }
        var filter = {
            idAlmacen: item.idAlmacen,
            fechaDesdeFormat: this.state.filter.fechaDesdeFormat,
            fechaHastaFormat: this.state.filter.fechaHastaFormat,
            idProducto: item.id,
            idMoneda: this.state.filter.idMoneda
        }

        const movimientosKardex = await kardexService.movimiento(filter);

        var newKardexDataSource = [];

        this.state.kardexDataSource.forEach(element => {
            var item = { ...element };
            newKardexDataSource.push(item);
        });

        newKardexDataSource.forEach(establecimiento => {
            establecimiento.almacenes.forEach(almacen => {
                if (almacen.id === item.idAlmacen) {
                    almacen.productos.forEach(producto => {
                        if (producto.id === item.id) {
                            producto.movimientos = movimientosKardex;
                        }
                    });
                }
            });
        });

        this.setState({ kardexDataSource: newKardexDataSource });
    }

    handleExportExcelDetallado = async () => {
        this.setState({ loadingExcel: true });
        var response = await kardexService.excelDetallado(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Kardex Detallado.xlsx");
    }

    handleExportExcelResumido = async () => {
        this.setState({ loadingExcel: true });
        var response = await kardexService.excelResumido(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Kardex Resumido.xlsx");
    }

    async componentDidMount() {
        this.setState({
            establecimientosLoading: true,
            monedasLoading: true
        });
        const establecimientos = await establecimientoService.principales();
        const monedas = await monedaService.listar();
        const productos = await productoService.listar();
        const productos_filter = productos.filter(m => m.idTipoProducto === 1);
        this.setState({
            establecimientos: establecimientos ? establecimientos : [],
            monedas: monedas ? monedas : [],
            productos: productos_filter ? productos_filter : [],
            establecimientosLoading: false,
            monedasLoading: false
        });
    }

    render() {
        return (
            <>
                <Header
                    title="Kardex"
                    onSearch={this.handleSearchKardexEstablecimiento}
                    onClearFilters={this.handleClearFilters}

                />
                <Filters
                    filter={this.state.filter}
                    establecimientos={this.state.establecimientos}
                    almacenes={this.state.almacenes}
                    monedas={this.state.monedas}
                    productos={this.state.productosAutocomplete}
                    establecimientosLoading={this.state.establecimientosLoading}
                    productosLoading={this.state.productosLoading}
                    almacenesLoading={this.state.almacenesLoading}
                    monedasLoading={this.state.monedasLoading}
                    onSearchAutocomplete={this.handleSearchAutocomplete}
                    onChangeAutocomplete={this.handleChangeAutocomplete}
                    onClearAutocomplete={this.handleClearAutocomplete}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}

                />

                <EstablecimientoTable
                    dataSource={this.state.kardexDataSource}
                    loadingExcel={this.state.loadingExcel}
                    onSearchKardexProducto={this.handleSearchKardexProducto}
                    onSearchKardexMovimiento={this.handleSearchKardexMovimiento}
                    onExportExcelDetallado={this.handleExportExcelDetallado}
                    onExportExcelResumido={this.handleExportExcelResumido}
                />
            </>
        )
    }
}